import { PointsModel } from "../contexts/GameContext";
import cupImage from '../assets/icon_desafios.png';

interface Props {
    data: PointsModel;
}

export function Points({ data }: Props) {
    return (
        <div className="points">
            <img src={cupImage} alt="Pontuação" />
            <p className="points">Pontuação: {data.current} / {data.max}</p>
        </div>
    );
}